import { Handle, type Node, type NodeProps, Position } from '@xyflow/react';
import type { FC } from 'react';
import type { ButtonNodeData } from './Nodes.utils';
import styles from './Nodes.module.scss';

/**
 * A generic action node for GraphCanvas: a single button whose `label`, `disabled` state, and `onClick`
 * callback are read from `node.data`. Consumers wire whatever behaviour they need via `onClick` (open a
 * modal, navigate, etc.), so this component holds no domain knowledge.
 *
 * Exposes a top target handle to connect it to a parent; the handle is visually hidden (read-only graph)
 * but still anchors the incoming edge.
 */
const ButtonNode: FC<NodeProps<Node<ButtonNodeData>>> = ({ data }) => {
  const { label, disabled = false, onClick } = data;

  return (
    <div className={styles.buttonWrapper} data-test-component="ButtonNode">
      <Handle type="target" position={Position.Top} isConnectable={false} className={styles.handle} />
      <button type="button" className={styles.button} disabled={disabled} onClick={onClick} data-test-element="button">
        {label}
      </button>
    </div>
  );
};

export default ButtonNode;
